// user profile and logout button

import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase'; // Import your Firebase authentication instance


function Profile() {
    const [user] = useAuthState(auth);

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                {/* Profile Header Card */}
                <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
                    {user ? (
                        <div className="flex flex-col md:flex-row items-center gap-6">
                            <img
                                className="w-32 h-32 rounded-full object-cover border-4 border-gradient-to-r from-pink-600 to-purple-600 shadow-lg"
                                src={user.photoURL || '/default-avatar.png'}
                                alt="User Avatar"
                            />
                            <div className="text-center md:text-left">
                                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{user.displayName || 'User'}</h2>
                                <p className="text-lg text-gray-600 mb-4">{user.email}</p>
                                <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                                    <span className="px-4 py-2 bg-gradient-to-r from-pink-50 to-purple-50 text-pink-700 rounded-full text-sm font-semibold">
                                        Member since {new Date(user.metadata.creationTime).toLocaleDateString()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-8">
                            <p className="text-xl text-gray-600">You are not logged in.</p>
                            <button
                                onClick={() => window.location = '/login'}
                                className="mt-4 px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-semibold rounded-lg hover:shadow-lg transition-all"
                            >
                                Login Now
                            </button>
                        </div>
                    )}
                </div>

                {/* Navigation Buttons */}
                {user && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <button
                            onClick={() => window.location = '../recipes/myrecipes'}
                            className="bg-gradient-to-r from-pink-600 to-purple-600 text-white py-8 px-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
                        >
                            <div className="text-center">
                                <div className="text-5xl mb-4">👨‍🍳</div>
                                <h3 className="text-2xl font-bold mb-2">My Recipes</h3>
                                <p className="text-white/90 text-sm">View and manage your recipes</p>
                            </div>
                        </button>

                        <button
                            onClick={() => window.location = '../recipes/savedrecipes'}
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-8 px-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
                        >
                            <div className="text-center">
                                <div className="text-5xl mb-4">❤️</div>
                                <h3 className="text-2xl font-bold mb-2">Saved Recipes</h3>
                                <p className="text-white/90 text-sm">Your favorite recipes</p>
                            </div>
                        </button>

                        <button
                            onClick={() => window.location = '/'}
                            className="bg-gradient-to-r from-teal-500 to-emerald-600 text-white py-8 px-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
                        >
                            <div className="text-center">
                                <div className="text-5xl mb-4">🔍</div>
                                <h3 className="text-2xl font-bold mb-2">Search Recipes</h3>
                                <p className="text-white/90 text-sm">Discover new recipes</p>
                            </div>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Profile;
